module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// c:/xampp74/htdocs/neutrik-opticalcon_fe/node_modules/axios/index.js
// module id = 7
// module chunks = 0